import React from 'react';

const DirectoryIcon = (props) => {

  let { 
    height, 
    width, 
    iconColor,
  } = props;
    
  return (
    <svg 
      width={width ? width : '17px'} 
      height={height ? height : '19px'} 
      viewBox="0 0 17 19" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Directory</title>
      <g id="V.4-Design-Change" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="company-filter--copy-2" transform="translate(-1079.000000, -31.000000)" fillRule="nonzero" fill={iconColor}>
          <path d="M1090.2784,40.5684 L1089.982,40.462 C1089.5336,40.2948 1089.5336,40.2036 1089.5336,39.9984 
            C1089.5336,39.8312 1089.602,39.588 1089.7388,39.4816 C1090.2556,39.0788 1090.5368,38.4936 1090.5368,37.84 
            C1090.5368,36.7076 1089.7084,35.56 1088.1276,35.56 C1086.7368,35.56 1085.7716,36.4948 1085.7716,37.84 
            C1085.7716,38.5164 1086.0376,39.0864 1086.5392,39.4816 C1086.638,39.5652 1086.7064,39.7628 1086.7064,40.0364 
            C1086.7064,40.2112 1086.7064,40.3024 1086.2732,40.462 L1085.9768,40.5684 C1084.966,40.9332 1083.5752,41.4272 
            1083.5752,42.97 L1083.5752,43.0764 C1083.5752,43.5552 1083.94,43.92 1084.4188,43.92 L1091.92,43.92 
            C1092.3836,43.92 1092.68,43.5856 1092.68,43.0764 L1092.68,42.97 C1092.68,41.4196 1091.2892,40.9256 
            1090.2784,40.5684 Z M1091.92,43.0764 C1091.92,43.122 1091.9124,43.1524 1091.92,43.16 L1084.4112,43.16 
            C1084.3656,43.16 1084.3276,43.1524 1084.3276,43.0764 L1084.3276,42.97 C1084.3276,42.0276 1085.08,41.6932 
            1086.2276,41.2828 L1086.5316,41.1764 C1087.398,40.8572 1087.4664,40.4164 1087.4664,39.9984 C1087.4664,39.7704 
            1087.4208,39.2156 1087.018,38.8888 C1086.6988,38.638 1086.5392,38.2884 1086.5392,37.84 C1086.5392,37.1408 
            1086.9572,36.32 1088.1352,36.32 C1089.2752,36.32 1089.7844,37.08 1089.7844,37.84 C1089.7844,38.2732 
            1089.6172,38.6228 1089.2752,38.8888 C1088.9104,39.1776 1088.7888,39.664 1088.7888,40.0212 C1088.7888,40.4088 
            1088.8572,40.8496 1089.7388,41.1764 L1090.0428,41.2904 C1091.1904,41.7008 1091.9428,42.0352 1091.9428,42.9776 
            L1091.9428,43.0764 L1091.92,43.0764 Z M1094.77,31 L1080.71,31 C1080.1856,31 1079.76,31.4256 1079.76,31.95 
            L1079.76,34.04 L1079,34.04 L1079,34.8 L1079.76,34.8 L1079.76,37.08 L1079,37.08 L1079,37.84 L1079.76,37.84 
            L1079.76,40.12 L1079,40.12 L1079,40.88 L1079.76,40.88 L1079.76,43.16 L1079,43.16 L1079,43.92 L1079.76,43.92 
            L1079.76,46.2 L1079,46.2 L1079,46.96 L1079.76,46.96 L1079.76,49.05 C1079.76,49.5744 1080.1856,50 1080.71,50 
            L1094.77,50 C1095.2944,50 1095.72,49.5744 1095.72,49.05 L1095.72,31.95 C1095.72,31.4256 1095.2944,31 1094.77,31 
            Z M1094.96,49.05 C1094.96,49.1564 1094.8764,49.24 1094.77,49.24 L1080.71,49.24 C1080.6036,49.24 1080.52,49.1564 
            1080.52,49.05 L1080.52,46.96 L1081.28,46.96 L1081.28,46.2 L1080.52,46.2 L1080.52,43.92 L1081.28,43.92 
            L1081.28,43.16 L1080.52,43.16 L1080.52,40.88 L1081.28,40.88 L1081.28,40.12 L1080.52,40.12 L1080.52,37.84 
            L1081.28,37.84 L1081.28,37.08 L1080.52,37.08 L1080.52,34.8 L1081.28,34.8 L1081.28,34.04 L1080.52,34.04 
            L1080.52,31.95 C1080.52,31.8436 1080.6036,31.76 1080.71,31.76 L1094.77,31.76 C1094.8764,31.76 1094.96,31.8436 
            1094.96,31.95 L1094.96,49.05 Z" 
            id="Contacts"></path>
        </g>
      </g>
    </svg>
  );
};

export default DirectoryIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/DirectoryIcon/index.js